/**
 * How long an element has to keep staying within user's viewport to make it a valid impression
 */
export const IMPRESSION_DURATION = 1000;

/**
 * The percentage of an element that must intersect with user's viewport
 */
export const INTERSECTION_PERCENTAGE = 0.5;

export enum TrackingOperation {
  Click = 'click',
  View = 'view',
  Impression = 'impression',
  // custom actions
  SetNewPasswordSuccessAction = 'action_set_new_password_success',
  LoginSuccessAction = 'action_login_success',
  LoginFailAction = 'action_login_fail',
  SignupSuccessAction = 'action_sign_up_success',
  OtpVerifyAction = 'action_otp_verify',
  AccountUpdateSuccessAction = 'action_account_update_success',
  ReclaimNumberSuccessAction = 'action_reclaim_number_success',
  ResetPasswordSuccessAction = 'action_reset_password_success',
  ErrorToastAction = 'action_error_toast',
  ChangePhoneSuccessAction = 'action_change_phone_success',
  ChangePhoneFailAction = 'action_change_phone_fail',
  ChangeEmailSuccessAction = 'action_change_email_success',
  ChangeEmailFailAction = 'action_change_email_fail',
  DelinkSuccessAction = 'action_delink_success',
  ThirdPartyActionConnectedSuccess = 'action_connected_third_party_success',
  ThirdPartyActionConnectedFail = 'action_connected_third_party_fail',
  LoginTokenSuccessAction = 'action_login_token_success',
}

export enum TrackingSource {
  RWeb = 'rweb',
  PC = 'pc',
  IOS = 'ios',
  Android = 'android',
}
